import { ExprError } from '../ExprError';
import { validateArguments } from '../../SignatureValidation';
export var MinFn;
(function (MinFn) {
    MinFn.Name = `MIN`;
    MinFn.Stage = "AGGREGATE";
    MinFn.Signature = `MIN(<column-expression>)`;
    function make(callName, args, type, role) {
        return {
            name: MinFn.Name,
            stage: MinFn.Stage,
            data: { type, role },
        };
    }
    MinFn.make = make;
    function validate(callNode, callName, args) {
        const arity = args.length;
        const sig = {
            meta: { name: MinFn.Name, signature: MinFn.Signature, location: callNode.location },
            arguments: [{}],
        };
        if (arity !== 1) {
            return [
                new ExprError.InvalidArgument(MinFn.Name, null, `expected 1 argument, received ${arity}`, callNode.location),
            ];
        }
        return validateArguments(sig, args);
    }
    MinFn.validate = validate;
})(MinFn || (MinFn = {}));
